
import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { useMedia } from "./context";
import { Button } from "@/components/ui/button";

interface EditModeOverlayProps {
  forceEditMode?: boolean;
}

const EditModeOverlay: React.FC<EditModeOverlayProps> = ({ forceEditMode = false }) => {
  const { language } = useLanguage();
  const { isEditMode, setIsEditMode } = useMedia();

  if (!isEditMode || forceEditMode) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 w-full bg-palsustain-charcoal/90 text-white py-2 z-30">
      <div className="container mx-auto px-4 flex justify-between items-center">
        <h2 className="text-lg font-medium">
          {language === "en" ? "Edit Mode" : "وضع التعديل"}
        </h2>
        <Button 
          variant="outline" 
          className="text-white border-white hover:bg-white/20"
          onClick={() => setIsEditMode(false)}
        >
          {language === "en" ? "Exit Edit Mode" : "الخروج من وضع التعديل"}
        </Button>
      </div>
    </div>
  );
};

export default EditModeOverlay;
